@let geConnector = connectors().GENERAL_ELECTRIC;

<div>
    <h3>{{ "connector.sectionTitle" | translate }}</h3>
    <div class="form-group-content">
        <p class="description">{{ "connector.description" | translate }}</p>
        <div class="switch-container">
          @if (geConnector) {
            <evc-checkbox
              [inputId]="geConnector.connectorName"
              [checked]="geConnector.isEnabled"
              [value]="geConnector.isEnabled"
              [disabled]="isLoading()"
              (click)="onToggleChange(geConnector)">
              <span label>{{ 'connectors.generalElectricAerospace' | translate }}</span>
            </evc-checkbox>
          }
        </div>
    </div>
</div>
